__turbopack_context__.v({
  "childFlexItem": "fHDMLG_childFlexItem",
  "flexItems": "fHDMLG_flexItems",
  "itemsWrapper": "fHDMLG_itemsWrapper",
  "jobiqo-select__wrapper": "fHDMLG_jobiqo-select__wrapper",
});
